// todo
export const ToImage = (url: string): string => {
  // return "https://ck.jixinkuai.com/api/file" + url;
  // return "https://api.jixinkuai.com/api/file" + url;
  // return "https://sxapi.jixinkuai.com/api/file" + url;
  return "https://jxk.jixinkuai.com/api/file" + url;
  // return "http://192.168.1.20:8100/api/file" + url;
};
